'use client';

import { useState } from 'react';

import type { Dispatch, SetStateAction } from 'react';

export const useLoading = (
  initialState = false
): [boolean, Dispatch<SetStateAction<boolean>>] => useState<boolean>( initialState );
